import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";
import { WonItemsWithDialog } from "./WonItemsWithDialog";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Chest Open">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StatusSection task={task} />

        <StringValue
          label={"Chest to open at once"}
          value={task.taskstatusdetail.chestsToOpenAtOnce}
        />
        <StringArray
          label={"Chests To Include"}
          array={task.taskstatusdetail.userInputIncludeChestNames}
        />
        <StringArray
          label={"Chests To Exclude"}
          array={task.taskstatusdetail.userInputExcludeChestNames}
        />
        <StringValue
          label={"Currently Opening Chest"}
          value={task.taskstatusdetail.currentlyOpeningChest}
          valueParser={(v) =>
            `${v.itemname} (Left To
              Open:${v.itemcount})`
          }
        />
        <WonItemsWithDialog
          label={"Opened Chests"}
          countlabel={"Total Chest Types Opened"}
          value={task.taskstatusdetail.chestsProcessed}
        />
        <WonItemsWithDialog
          label={"Won Items"}
          countlabel={"Total Item Types"}
          value={task.taskstatusdetail.itemswon}
        />
        <WonItemsWithDialog
          label={"End Gains"}
          countlabel={"Net Items Gained"}
          value={task.taskstatusdetail.endItems}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
